var scrollAreaRoot = 'fx_2d2fb1e5_8ytjsl0';
var scrollbarMarginTop = 'var(--fx_2d2fb1e5_8ytjsl1)';

export { scrollAreaRoot, scrollbarMarginTop };
//# sourceMappingURL=scrollArea.vanilla.mjs.map
